// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  AcompanhamentoLogRpa,
} from './';

export default {
  path: 'logs-sistema',
  name: 'Logs sistema',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'logs-rpa', name: 'Acompanhamento log rpa', component: AcompanhamentoLogRpa },
  ],
};



// WEBPACK FOOTER //
// ./src/features/logs-sistema/route.js